import { useInfiniteQuery } from "@tanstack/react-query";

import { axiosInstance } from "../axios/axiosInstance";

export const key = ["noteKey"];
export const useGetInfiniteNotes = (userData) =>
  useInfiniteQuery(
    [...key, userData],
    async () => {
      const { data } = await axiosInstance.get(`agent/loop/notes/`, {
        params: {
          main_username: userData.main_username,
          second_username: userData.second_username,
        },
      });
      return data.notes;
    },
    {
      getNextPageParam: (lastPage) => {
        return lastPage.meta?.current_page < lastPage.meta?.last_page
          ? lastPage.meta?.current_page + 1
          : undefined;
      },
      select: (data) => {
        return data?.pages;
      },
      enabled: !!userData,
    }
  );
